<template>
  <article>
    <TagGroup
      class=""
      :tags="
        tags.filter(
          (x) =>
            x.attributes?.group !== 'content-warnings' &&
            x.attributes?.group !== 'admin-only',
        )
      "
      small
    >
      <Tag
        v-if="primaryGenre && primaryGenre.id"
        type="primary"
        :tag="primaryGenre.id"
      >
        {{ $t(`components.tag.${primaryGenre.id}.name`) }}
      </Tag>
      <Tag
        v-if="secondaryGenre && secondaryGenre.id"
        type="secondary"
        :tag="secondaryGenre.id"
      >
        {{ $t(`components.tag.${secondaryGenre.id}.name`) }}
      </Tag>
      <Tag
        v-for="tag in tags.filter((x) => x.attributes?.group === 'admin-only')"
        :type="getAwardColor(tag.id)"
        :tag="tag.id"
        small
        >{{ $t(`components.tag.${tag.id}.name`) }}
      </Tag>
      <!--      <Tag v-if="demographic && demographic !== 'none'" small-->
      <!--        >{{ $t(`components.demographic.${demographic}`) }}-->
      <!--      </Tag>-->
      <template #postpend>
        <Tag
          v-for="tag in tags.filter(
            (x) => x.attributes?.group === 'content-warnings',
          )"
          type="danger"
          small
          :tag="tag.id"
          >{{ $t(`components.tag.${tag.id}.name`) }}
        </Tag>
      </template>
    </TagGroup>
    <div class="text-sm sm:text-base mt-4">
      <!--      TODO: [Jan 27, 2025] We have migrated to marked.js that works both server and client side.-->
      <!--      A quick check to see if we want MD in title descriptions is left.-->
      <p>
        <!--        <MarkdownRender :text="description" />-->
        {{ description }}
      </p>
    </div>
  </article>
</template>

<script setup lang="ts">
import type { TitleEntity } from "~/src/api";
import { parseTitleForDisplay } from "~/utils/display/title";

interface Props {
  titleEntity: TitleEntity;
}

const props = defineProps<Props>();

const { description, tags, primaryGenre, secondaryGenre, demographic } =
  parseTitleForDisplay(computed(() => props.titleEntity));

const getAwardColor = (tag: string) => {
  if (tag === "namis-tt-gold-winner") return "gold";
  if (tag === "namis-tt-silver-winner") return "silver";
  return "primary";
};
</script>
